<template>
  <div id="dashboardcontainer">
    <div id="actioncontainer">
      <div class="d-flex">
        <div>
          <input
            type="search"
            placeholder="Search by project name.."
            class="form-control"
            id="projectsearch"
            v-model="projectName"
            @input="filterWalletRequests()"
          />
        </div>
        <div class="ml-2">
          <select
            class="custom-select"
            v-model="status"
            @change="filterWalletRequests()"
          >
            <option value="All">All</option>
            <option v-for="s in statuses" :key="s.title" :value="s.title">
              {{ s.title }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <button
          class="btn bgprimarycolor text-white"
          @click="createWalletRequest"
        >
          <font-awesome-icon
            class="fa-1x text-white mr-1"
            title="Create wallet request"
            :icon="['fas', 'plus']"
          />Create Wallet Request
        </button>
      </div>
    </div>

    <div id="requestcontainer">
       <DataTable ref="walletRequest" :sortField="sortField" :sortOrder="sortOrder" :value="requests" :rows="pageSize" :paginator="true" :totalRecords="totalRecords"  @page="onPage($event)" @sort="onSort($event)" 
             dataKey="id" :lazy="true" :loading="is_loading" :first="startIndex">
      <Column field="ProjectDetails.Name"  #body="slotProps" header="Project Name" :sortable="true" :style="{ 'width': '13%' }">{{ slotProps.data.projectDetails.name}}</Column>
      <Column field="cryptoType" header="Crypto Type" :style="{ 'width': '6%' }"></Column>
      <Column header="Wallet ID" :style="{ 'width': '29%' }">
        <template #body="slotProps">
          <div class="position-relative">
             {{ slotProps.data.walletId }}
              <span data-title="Copy Wallet Id">
                <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'copy']"
                  @click="copyText(slotProps.data.walletId, 'requestcontainer')"
                />
              </span>
              <CheckWallet :cur-wallet-id="slotProps.data.walletId" />
              <template
                v-if="isInfoVisible(slotProps.data,slotProps.data.walletId)"
              >
                <References :request="slotProps.data" :walletId="slotProps.data.walletId"  :walletType="'primary'"/>
              </template>
                <div v-if="slotProps.data.secondaryWalletId">
                <hr>
                 {{ slotProps.data.secondaryWalletId }}
                <span data-title="Copy Wallet Id">
                <font-awesome-icon
                  class="fa-1x infoicon align-middle text-info"
                  :icon="['fas', 'copy']"
                  @click="copyText(slotProps.data.secondaryWalletId, 'requestcontainer')"
                />
              </span>
              <CheckWallet :cur-wallet-id="slotProps.data.secondaryWalletId" />
              <template
                v-if="isInfoVisible(slotProps.data,slotProps.data.secondaryWalletId)"
              >
               <References :walletType="'secondary'" :request="slotProps.data" :walletId="slotProps.data.secondaryWalletId" />
                </template>
                </div>
            
          </div>
        </template>
      </Column>
      <Column header="Created Date"  field="CreatedAt" :style="{ 'width': '10%' }" :sortable="true"> <template #body="slotProps">{{ slotProps.data.createdAt| formatDate }} </template></Column>
      <Column field="status" header="Status" :style="{ 'width': '6%' }"></Column>
       <Column header="Details" :style="{ 'width': '30%' }">
       <template #body="slotProps">
      <b>Request Id</b>
      : {{ slotProps.data.paymentRequestId }}
      <br />
      <b>Created by</b>
      {{ slotProps.data.createdBy }}
      <b>At</b>
      {{ slotProps.data.createdAt | formatDate }}
       </template>
       </Column>
      <Column header="" :style="{ 'width': '10%' }">
        <template #body="slotProps">
          <div class="d-flex justify-content-center">
            <div>
              <button class="btn bgprimarycolor text-white mr-2" data-title="View Details" @click="viewDetails(slotProps.data.paymentRequestId)">
                <font-awesome-icon class="fa-1x text-white" :icon="['fas', 'eye']" />
              </button>
            </div>
          </div>
        </template>
      </Column>
    </DataTable>
    </div>
  </div>
</template>
<script>
import walletService from "../services/walletService";
import ProcessRequest from "./ProcessRequest";
import PayRequest from "./PayRequest";
import { mapState } from "vuex";
import { EventBus } from "../EventBus";
import References from "./References";
import RejectRequest from "./RejectRequest";
import CheckWallet from "./CheckWallet";

export default {
  name: "Dashboard",
  components: {
    ProcessRequest,
    PayRequest,
    References,
    RejectRequest,
    CheckWallet,
  },

  computed: {
    ...mapState({
      requests: (state) => state.walletRequests,
      statuses: (state) => state.statuses,
    }),
  },
  created() {
    this.loadGridState();
    EventBus.$emit("toast", {
      title: "",
      message: "Fetching Wallet Requests",
      variant: "success",
    });
    this.getWalletRequests();
  },
  mounted() {
    let theTable = this.$refs.walletRequest;
    this.paginator = theTable.$children.filter((c) => c.$options._componentTag === "DTPaginator")[0];
  },
  data() {
    return {
      projectName: "",
      paginator: null,
      status: "All",
      pageNumber: 0,
      pageSize: 25,
      totalRecords: 0,
      sortOrder: -1,
      sortField:"CreatedAt",
      is_loading: true,
      sortIcon: ["fas", "sort"],
      startIndex: 0,
      debounce: this.createDebounce(),
      theTable: {},
    };
  },
  methods: {
    setPage(pageNumber) {
        this.startIndex = pageNumber * this.pageSize;
        this.paginator.d_first = this.startIndex;
    },
    isInfoVisible(request, walletId) {
      if (request.projectReferences && request.projectReferences.length > 0) {
        let projectreference = request.projectReferences.filter((i) => {
          if (i.walletId == walletId || i.walletId == null) return i;
        });
        return projectreference.length > 0;
      }
      return false;
    },
    loadGridState() {
      let walletGridState = sessionStorage.getItem("walletrequest");
      if (walletGridState) {
        walletGridState = JSON.parse(sessionStorage.getItem("walletrequest"));
        this.pageNumber = walletGridState.pageNumber
          ? walletGridState.pageNumber
          : 0;
        this.pageSize = walletGridState.pageSize
          ? walletGridState.pageSize
          : 25;
        this.projectName = walletGridState.projectName
          ? walletGridState.projectName
          : "";
        this.status = walletGridState.status ? walletGridState.status : "All";
        this.sortOrder = walletGridState["ColumnOrder.OrderBy"]
          ? walletGridState["ColumnOrder.OrderBy"]
          : -1;
        this.sortField = walletGridState["ColumnOrder.ColumnName"];
        this.startIndex = this.pageSize * this.pageNumber;
      } else {
        this.pageNumber = 0;
        this.pageSize = 25;
      }
      this.getWalletRequests();
    },
    createDebounce() {
      let timeout = null;
      return (fnc, delayMs) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fnc();
        }, delayMs || 500);
      };
    },
    onPage($event) {
      this.pageNumber = $event.page;
      this.debounce(() => {
        this.getWalletRequests($event);
      });
    },
    getWalletRequests($event) {
      this.is_loading = true;
      const filter = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        projectName: this.projectName,
        "ColumnOrder.ColumnName": this.sortField,
        "ColumnOrder.OrderBy": this.sortOrder,
        status: this.status,
      };
      sessionStorage.setItem("walletrequest", JSON.stringify(filter));
      filter.pageNumber=(filter.pageNumber+1);
      Promise.all([
        walletService.getWalletRequests(filter),
        walletService.getWalletStatuses(),
      ]).then((response) => {
        this.manageData(response[0].data.data);
        this.$store.commit("addWalletStatuses", response[1].data.data);
      });
    },
    onSort($event) {
      this.sortOrder = $event.sortOrder;
      this.sortField = $event.sortField;
      this.pageNumber = 0;
      this.getWalletRequests();
    },
    mapEvent() {
      let $event = {};
      $event.sortOrder = this.sortOrder ? this.sortOrder : 0;
      $event.pageNumber = this.pageNumber;
      $event.rows = this.pageSize ? this.pageSize : 25;
      $event.totalRecords = this.totalRecords;
      return $event;
    },
    manageData(data) {
      const { requests, pagination } = data;
      this.pageNumber = pagination.page_number-1;
      this.totalRecords = pagination.count;
      this.$store.commit("addWalletRequests", requests);
      this.setPage(pagination.page_number-1);
      this.is_loading = false;
    },
    createWalletRequest() {
      this.$router.push({ name: "create-request-view" });
    },
    viewDetails(id) {
      this.$router.push(`/request/${id}/details`);
    },
    editDetails(id) {
      this.$router.push(`/request/${id}/edit`);
    },
    filterWalletRequests() {
      this.debounce(() => {
        let e = this.mapEvent();
        e.pageNumber = 0;
        this.getWalletRequests(e);
      });
    },
    loadWalletRequest() {
      getWalletRequests();
    },
  },
};
</script>

<style lang="scss" scoped>
#dashboardcontainer {
  width: 93%;
  margin: auto;
  margin-top: 2rem;
}
#actioncontainer {
  display: flex;
  justify-content: space-between;
}

#requestcontainer {
  margin-top: 2rem;
  th {
    position: sticky;
    background-color: $primary-color;
    border-color: #c7cacc;
    color: white;
    z-index: 48;
  }

  td {
    vertical-align: middle;
  }
}

#projectsearch {
  width: 300px;
}

.filterborderinactive {
  border: 1px solid #00000085;
  border-radius: 25px;
}
</style>